/**
 * Merchant orders list hook.
 *
 * `/orders/merchant/{merchantId}` is typed in the OpenAPI build.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@favelafood/shared/api/client';
import type { components } from '@favelafood/shared/api/generated/api';
import { merchantOpsKeys, unwrap } from './keys';

export type OrderPage = components['schemas']['PageResponseOrderResponse'];

export function useMerchantOrders(
  merchantId: string | null,
  page: number,
  size: number,
): UseQueryResult<OrderPage, Error> {
  return useQuery<OrderPage, Error>({
    queryKey: merchantOpsKeys.orders(merchantId ?? 'none', page, size),
    enabled: merchantId !== null,
    queryFn: async () => {
      if (!merchantId) throw new Error('Selecione um estabelecimento');
      const { data, error } = await api.GET('/api/v1/orders/merchant/{merchantId}', {
        params: { path: { merchantId }, query: { page, size } },
      });
      return unwrap(data, error);
    },
  });
}
